import type { SxProps, Theme } from '@mui/material'

export const styles = {
  root: {
    display: 'grid',
    gridTemplateColumns: '1fr auto',
    alignItems: 'center',
    gap: 1,
    minHeight: 32,
    pb: 1,
  },
} satisfies Record<string, SxProps<Theme>>
